import { useQuery } from 'react-query';
import { ProjectEstimateAssemblyService as peas } from '../api/ProjectEstimateAssemblyService';
import { EstimateTakeoffAssemblies } from '../api/protosCompiled/estimateAssembly/estimateAssembly_pb';

export function useFetchAssembliesByEstimateId(estimateId: string) {
  const fetchAssemblies = async () => {
    if (!estimateId) {
      return [];
    }
    const response = await peas.getEstimateAssembliesByEstimateId(estimateId);
    return response.takeoffassembliesList || [];
  };

  const { data, error, isLoading } = useQuery<
    EstimateTakeoffAssemblies.AsObject[],
    Error
  >(['assembliesByEstimateId', estimateId], fetchAssemblies, {
    enabled: !!estimateId,
    staleTime: 10000, // Consider data fresh for 10 seconds
    cacheTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  return { data, error, isLoading };
}
